export function getHostName() {
  const HREF_SPLIT = window.location.href.split("://");
  return HREF_SPLIT[0] + "://" + HREF_SPLIT[1].split("/")[0];
}
